import { render, staticRenderFns } from "./SelectModalContentsCategory.vue?vue&type=template&id=3b95fbb6"
import script from "./SelectModalContentsCategory.vue?vue&type=script&lang=js"
export * from "./SelectModalContentsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports